import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FieldAgentClient, NotepadType, Mode } from 'ep-bt-field-agent-proxy';
import { BistrackConfig, Right, PermissionLevel, SearchPageNames } from 'ep-bt-controls';
import { EpbtFieldAgentService } from '../../services/epbt-field-agent.service';

@Component({
  selector: 'epbt-fa-notepadtype-list',
  templateUrl: './epbt-fa-notepadtype-list.component.html',
  styleUrls: ['./epbt-fa-notepadtype-list.component.scss']
})
export class EpbtFaNotepadtypeListComponent implements OnInit {

  @Input() notepadTypes: any[] = [];
  @Input() disabled: boolean = false;
  @Input() isEditable: boolean = true;
  // private _selectedNotepadType: NotepadType;
  // @Input('selectedNotepadType') set selectedNotepadType(value: NotepadType) {
  //   this._selectedNotepadType = value;
  //   this.notepadTypeChange.emit(this._selectedNotepadType);
  // }
  // get selectedNotepadType(): NotepadType {
  //   return this._selectedNotepadType;
  // }

  private _selectedNotepadType: number;
  @Input('selectedNotepadType') set selectedNotepadType(value: number) {
    this._selectedNotepadType = value;
    if (this._selectedNotepadType) {
      var result = this.notepadTypes.filter(x => x.notepadTypeID == this._selectedNotepadType);
      this.notepadTypeChange.emit(result ? result[0] : null);
    }
  }
  get selectedNotepadType(): number {
    return this._selectedNotepadType;
  }

  @Output() notepadTypeChange = new EventEmitter<any>();
  @Input() page: string;
  label: string;
  constructor(private client: FieldAgentClient, private config: BistrackConfig, private faService: EpbtFieldAgentService) { }

  ngOnInit() {
    this.label = (this.page == SearchPageNames.CustomerNotepad || this.page == SearchPageNames.DashboardNotepadSearch) ? "Type" : "Type*";
    this.GetNotepadTypes();
  }

  onSelectionChange(selectedValue: any) {
    if (selectedValue) {
      // this.selectedNotepadType = selectedValue;
      // this.notepadTypeChange.emit(this.selectedNotepadType);
      // console.log("EpbtFaNotepadtypeListComponent - onSelectionChange - Start");
      this.selectedNotepadType = selectedValue.notepadTypeID;
      var result = this.notepadTypes.filter(x => x.notepadTypeID == this.selectedNotepadType);
      this.notepadTypeChange.emit(result ? result[0] : null);
      // console.log("EpbtFaNotepadtypeListComponent - onSelectionChange - End");
    }
  }

  async GetNotepadTypes() {
    this.faService.getBisTrackSetting((bistrackSettings: any) => {
      this.faService.getWebTrackUser((webTrackUser: any) => {
        let userHasCreditControlRead: boolean = false;
        let userPerm = webTrackUser.rights.find(item => item.name == Right.NotepadCreditControl);
        if (userPerm && userPerm.permission)
          userHasCreditControlRead = userPerm.permission.perRead == PermissionLevel.PleGranted || userPerm.permission.perRead == PermissionLevel.PleInherited;
        let mode = (this.page == SearchPageNames.CustomerNotepad || this.page == SearchPageNames.DashboardNotepadSearch) ? Mode.View : Mode.Add;
        let userId = this.page == SearchPageNames.CustomerNotepad ? 0 : this.config.getLoggedinUser();
        this.client.getCustomerNotepadTypes(mode, userHasCreditControlRead, userId).subscribe(res => {
          this.notepadTypes = res;
          if (this.page == SearchPageNames.CustomerNotepad || this.page == SearchPageNames.DashboardNotepadSearch)
            this.notepadTypes = this.notepadTypes.filter(item => item.name != "Notification");
          if (!bistrackSettings.licensing.crmEnabled)
            this.notepadTypes = this.notepadTypes.filter(item => item.name != "Campaign Notes");

          if (this._selectedNotepadType) {
            var result = this.notepadTypes.filter(x => x.notepadTypeID == this._selectedNotepadType);
            this.notepadTypeChange.emit(result ? result[0] : null);
          }
        });
      });
    });
  }
}
